import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { DetailActionButton, IconType, IoniconsOutline } from '@pt/pt-models';

@Injectable({
  providedIn: 'root'
})
export class DetailsPageService {
  constructor(private translateService: TranslateService) {
  }

  DefaultActionButtons(): DetailActionButton[] {
    return [
      {
        icon: {
          key: IoniconsOutline.edit,
          type: IconType.IONIC_ICON,
          size: 14
        },
        label: this.translateService.stream('BUTTON.OPEN'),
        id: 'edit',
        class: 'btn btn-sm btn-secondary mb-1 mt-1 me-1 ms-0'
      },
      {
        icon: {
          key: IoniconsOutline.trash,
          type: IconType.IONIC_ICON,
          size: 14
        },
        label: this.translateService.stream('BUTTON.DELETE'),
        id: 'delete',
        class: 'btn btn-sm btn-danger m-1'
      }
    ];
  }
}
